export default __webpack_public_path__ + "resources/icons/n222-aac2.png";